import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { currentUser, userRoles } = useAuth();

  // Redirect to appropriate page once user is authenticated
  useEffect(() => {
    if (currentUser && userRoles) {
      const isAdmin = Array.isArray(userRoles) ? userRoles.includes('Admin') : userRoles === 'Admin';
      if (isAdmin) {
        navigate('/dashboard');
      } else {
        navigate('/lakes');
      }
    }
  }, [currentUser, userRoles, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Navigation will happen in useEffect once auth state is set
    } catch (error) {
      setError('Failed to log in: ' + error.message);
    }
  };

  return (
    <div className="login-container">
      <img 
        src={require('../../assets/Logo2_Version1.png')} 
        alt="Musky Metrics Logo" 
        className="login-logo"
      />
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default Login;
